import { Injectable } from '@angular/core';
import { ISharedTwilioResponse } from '@g99-product-web-ui/shared-interface-lib';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';
import { Observable } from 'rxjs';

import { ServiceType } from '../../constants/service-types.enum';
import { HttpService } from '../../core/http-service/http.service';

@Injectable({
  providedIn: 'root',
})
export class SharedTwilioSetupService {
  constructor(private readonly _httpService: HttpService) {}

  public getTwilioSavedData(): Observable<ISharedTwilioResponse> {
    const url = API_ENDPOINTS.TWILIO_ENDPOINTS.getTwilioResponse();
    return this._httpService.get<ISharedTwilioResponse>(
      url,
      {
        attachTenantId: true,
      },
      ServiceType.DEFAULT
    );
  }
}
